<script>
import DateTimePicker from '@/components/directives/DateTimePicker.vue';

export default {
  name: 'RobFormModal',
  components: { DateTimePicker },
  props: {
    visible: Boolean,
    isEditMode: Boolean,
    isSubmitting: Boolean,
    initialData: Object,
    assets: { type: Array, default: () => [] },
    defaultAssetId: { type: [Number, String], default: null },
  },
  data() {
    return {
      form: {
        mrobId: null,
        mrobMassId: null,
        startTime: new Date(),
        endTime: new Date(),
        initialValue: null,
      },
    };
  },
  computed: {
    title() {
      return this.isEditMode ? 'Edit ROB Profile' : 'Create New ROB Profile';
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.isEditMode && this.initialData) {
          this.form = { ...this.initialData };
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        mrobId: null,
        mrobMassId: this.defaultAssetId,
        startTime: new Date(),
        endTime: new Date(),
        initialValue: null,
      };
    },
    handleSubmit() {
      if (!this.form.mrobMassId || !this.form.startTime || !this.form.endTime || !this.form.initialValue) {
        this.$toast.error('All fields are required.');
        return;
      }
      this.$emit('submit', this.form);
    },
    closeModal() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<template>
  <b-modal :visible="visible" :title="title" @hidden="closeModal" hide-footer>
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Asset">
        <b-form-select v-model="form.mrobMassId" required>
          <b-form-select-option :value="null" disabled>Select an asset</b-form-select-option>
          <b-form-select-option v-for="asset in assets" :key="asset.massId" :value="asset.massId">
            {{ asset.massName }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Start Date & Time">
        <date-time-picker v-model="form.startTime" />
      </b-form-group>
      <b-form-group label="End Date & Time">
        <date-time-picker v-model="form.endTime" />
      </b-form-group>
      <b-form-group label="Initial Supply in Liters">
        <b-form-input v-model="form.initialValue" type="number" required step="any"/>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="secondary" @click="closeModal" class="mr-2">Cancel</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">
          {{ isSubmitting ? 'Saving...' : 'Save' }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
